import { travelPassEnvConfig } from "./travel-pass/travel-pass-env-based-config";

const envConfig = {
  dev: {
    ackoBaseUrl: "https://www.ackodev.com",
    gmailConsentEndpoint: "https://acko-labs-ai-uat.internal.ackodev.com/api/consent/gcp/update",
    entityServiceEndpoint: "https://entity-service.internal.ackodev.com",
    safebuyApiHost: process.env.SAFEBUY_API_HOST || "https://central-acko-safe-buy-uat.internal.ackodev.com",
    segmentKey: {
      ackoSeo: "LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6",
      ackoLabs: "uLnWlZECj44wVNGXbeJ2t13gVGy2qRCD",
    },
    travelPass: travelPassEnvConfig.dev,
    travelBffEndpoint: "https://travel-retail-bff-uat.internal.ackodev.com",
  },
  uat: {
    ackoBaseUrl: "https://www.ackodev.com",
    gmailConsentEndpoint: "https://acko-labs-ai-uat.internal.ackodev.com/api/consent/gcp/update",
    entityServiceEndpoint: "https://entity-service.internal.ackodev.com",
    safebuyApiHost: process.env.SAFEBUY_API_HOST || "https://central-acko-safe-buy-uat.internal.ackodev.com",
    segmentKey: {
      ackoSeo: "LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6",
      ackoLabs: "uLnWlZECj44wVNGXbeJ2t13gVGy2qRCD",
    },
    travelPass: travelPassEnvConfig.uat,
    travelBffEndpoint: "https://travel-retail-bff-uat.internal.ackodev.com",
  },
  prod: {
    ackoBaseUrl: "https://www.acko.com",
    gmailConsentEndpoint: "https://acko-labs-ai.live.acko.com/api/consent/gcp/update",
    entityServiceEndpoint: "https://entity-service.internal.acko.com",
    safebuyApiHost: process.env.SAFEBUY_API_HOST || "https://central-acko-safe-buy.live.acko.com",
    segmentKey: {
      ackoSeo: "HXYpaTGkLGPf8NCthRHd56vpihGevRk6",
      ackoLabs: "KjpfQIxTN0OnIfjFBgt4rdiqtwlbHL0o",
    },
    travelPass: travelPassEnvConfig.prod,
    travelBffEndpoint: "https://travel-retail-bff.internal.live.acko.com",
  },
};

export function getEnvConfig(env: string) {
  if (!env) return envConfig.uat;
  if (env === "dev") return envConfig.dev;
  if (env === "prod") return envConfig.prod;
  return envConfig.uat;
}
